import { defineStore } from "pinia";

export type InfoPanelSetting = { type: "check", value: boolean } | { type: "dropdown", value: string, options: string[] };

interface InfoPanelStore {
  sections: { [type: string]: { [key: string]: boolean } };
  extraSettings: { [type: string ]: { [key: string]: InfoPanelSetting } };
}

export const useInfoPanelStore = defineStore("model/infoPanels", {
  state: (): InfoPanelStore => {
    return { sections: {}, extraSettings: {} };
  }
});